import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../auth/AuthContext";

export const useAvailableDashboards = () => {
  const { client, user } = useAuth();
  const [data, setData] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!user) {
      setData([]);
      setLoading(false);
      return;
    }
    const response = await client.get("/modules/dashboards/available");
    if (!response.ok) {
      setData([]);
      setLoading(false);
      return;
    }
    const payload = (await response.json()) as { data?: string[] };
    setData(payload.data ?? []);
    setLoading(false);
  }, [client, user]);

  useEffect(() => {
    void load();
  }, [load]);

  return { data, loading, reload: load };
};

